/**
 * Amplify Auth configuration for app-web (WS-D D2).
 *
 * Reads the Cognito ids from Vite env vars — injected at build time by the
 * StaticSite (`infra/app-web.ts`) for deployed builds, or from a gitignored
 * `.env.local` for local `npm run dev`. Email/password only (Cognito SRP); no
 * hosted-UI / Google OAuth block — Google is P2 (WS-E).
 *
 * `AMPLIFY_CONFIGURED` is the single gate the app keys off: it is false whenever
 * the ids are absent (local dev without the vars, and the CI/Playwright build,
 * which sets only VITE_APP_API_URL). The auth overlay only gates the dashboard
 * when this is true — so an unconfigured build renders the dashboard exactly as
 * before, keeping the committed VRT baselines and behavioural e2e untouched.
 * Ported + trimmed from world-cup-v2 `lib/amplify.ts`.
 */

import { Amplify } from "aws-amplify";

const USER_POOL_ID = import.meta.env.VITE_USER_POOL_ID;
const USER_POOL_CLIENT_ID = import.meta.env.VITE_USER_POOL_CLIENT_ID;

/** True only when both Cognito ids are present — see the module comment. */
export const AMPLIFY_CONFIGURED = Boolean(USER_POOL_ID && USER_POOL_CLIENT_ID);

if (AMPLIFY_CONFIGURED) {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: USER_POOL_ID as string,
        userPoolClientId: USER_POOL_CLIENT_ID as string,
      },
    },
  });
}
